import { Dispatch, SetStateAction } from 'react';

export const handleInputText = (
  event: React.ChangeEvent<HTMLInputElement>,
  setFunction: Dispatch<SetStateAction<string>>,
) => {
  setFunction(event.target.value);
};

export const handleInputNumber = (
  event: React.ChangeEvent<HTMLInputElement>,
  setFunction: Dispatch<SetStateAction<number | undefined>>,
) => {
  setFunction(Number(event.target.value));
};

export const handleInputTextWithoutComma = (
  event: React.ChangeEvent<HTMLInputElement>,
  setFunction: Dispatch<SetStateAction<string>>,
) => {
  const formattedValue = event.target.value
    .replace(/,/g, '')
    .replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xfee0));
  setFunction(formattedValue);
};

export const handleInputNumberWithoutCommaAndConvertToHalfWidth = (
  event: React.ChangeEvent<HTMLInputElement>,
  setFunction: Dispatch<SetStateAction<string>>,
) => {
  setFunction(
    event.target.value.replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xfee0)).replace(/[^\d]/g, ''),
  );
};
